import { useCallback } from 'react';

/*
 * A callback ref rather than an effect: the notice attaches long after the screen does, and an effect
 * with an empty dependency list runs once against a ref that is still null and never fires again.
 *
 * The control the tenant just pressed becomes disabled, which sends focus to `<body>` and leaves it
 * there until the next edit. Moving it to the notice also scrolls the reason into view.
 */
export const useFocusWhenShown = <T extends HTMLElement>(): ((node: T | null) => void) =>
  useCallback((node: T | null) => {
    node?.focus();
  }, []);
